export default "__VITE_ASSET__DQKa$JgL__"